module.exports = __webpack_public_path__ + "media/images/sprite/ico-instagram-e0300c8c8d0035159194ce17b4c490c9.png";